import React from 'react'
import { NextPage } from 'next'
import PublicLayout from 'src/components/Layout/public'
import { colors } from 'src/theme/colors'
import { useRouter } from 'next/router'
import { Title } from 'src/components/Common'
import { useDispatch, useSelector } from 'react-redux'
import ReactPlayer from 'react-player'
import { NewsContainer } from 'src/components/News/styles'
import { State } from 'src/store/rootReducers'
import { getNewsRequest } from 'src/store/news'
import { NewsPageSkeleton } from 'src/components/Skeleton/newsPage'
import formatText from 'src/utils/formatText'

const News: NextPage = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const params = router.query as { title: string; id: string }

  const news = useSelector((state: State) => state.news.news)
  const isLoading = useSelector((state: State) => state.news.isLoading)
  const desc = formatText(news?.description)

  React.useEffect(() => {
    if (params.title) {
      ;(async () => {
        await getTeacher()
      })()
    }
  }, [params.title, router.isReady])

  async function getTeacher() {
    dispatch(getNewsRequest(params.title))
  }

  return (
    <PublicLayout showCategory={false}>
      <NewsContainer>
        {isLoading ? (
          <NewsPageSkeleton />
        ) : (
          <>
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                controls
                url={news?.video}
                width="90%"
                height="90%"
              />
            </div>
            <div className="content-news">
              <Title
                borderMargin="medium"
                size="lg"
                borderColor={colors.palette.white}
                tx={news?.title ?? ''}
                hasBorder
                textAlign="left"
              />
              <div className="desc">{desc}</div>
            </div>
          </>
        )}
      </NewsContainer>
    </PublicLayout>
  )
}

export default News
